import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
  selector: 'message-tail',
  templateUrl: './message-tail.component.html',
  styleUrls: ['./message-tail.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class MessageTailComponent {}
